import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-25" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-2 mb-4" }
const _hoisted_4 = { class: "position-relative table-src-form me-0" }
const _hoisted_5 = { class: "default-table-area all-products px-20" }
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = { class: "table align-middle" }
const _hoisted_8 = { scope: "col" }
const _hoisted_9 = {
  class: "form-check d-flex align-items-center",
  style: {"gap":"10px"}
}
const _hoisted_10 = { class: "text-body" }
const _hoisted_11 = {
  class: "form-check d-flex align-items-center",
  style: {"gap":"10px"}
}
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "position-relative top-2" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "ms-2 ps-1" }
const _hoisted_16 = { class: "fs-13 text-body mb-1 d-block" }
const _hoisted_17 = { class: "fw-medium fs-15 text-secondary mb-0" }
const _hoisted_18 = { class: "text-secondary" }
const _hoisted_19 = { style: {"max-width":"300px"} }
const _hoisted_20 = { class: "text-secondary" }
const _hoisted_21 = { class: "text-secondary" }
const _hoisted_22 = { class: "d-flex align-items-center gap-1" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { class: "d-flex justify-content-center justify-content-sm-between align-items-center text-center flex-wrap gap-2 showing-wrap" }
const _hoisted_28 = { class: "fs-13" }
const _hoisted_29 = { "aria-label": "Page navigation example" }
const _hoisted_30 = { class: "pagination mb-0 justify-content-center" }
const _hoisted_31 = { class: "page-item" }
const _hoisted_32 = ["disabled"]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "page-item" }
const _hoisted_35 = ["disabled"]
const _hoisted_36 = {
  class: "modal fade",
  id: "propertyModal",
  tabindex: "-1",
  "aria-labelledby": "propertyModalLabel",
  "aria-hidden": "true"
}
const _hoisted_37 = {
  class: "modal-dialog modal-dialog-centered",
  style: {"max-width":"550px"}
}
const _hoisted_38 = { class: "modal-content rounded-0" }
const _hoisted_39 = { class: "modal-header border-0 p-4 border-bottom" }
const _hoisted_40 = { class: "modal-title fs-18" }
const _hoisted_41 = { class: "modal-body p-4" }
const _hoisted_42 = { class: "row" }
const _hoisted_43 = { class: "col-lg-6" }
const _hoisted_44 = { class: "form-group mb-4" }
const _hoisted_45 = { class: "col-lg-6" }
const _hoisted_46 = { class: "form-group mb-4" }
const _hoisted_47 = { class: "col-lg-6" }
const _hoisted_48 = { class: "form-group mb-4" }
const _hoisted_49 = { class: "col-lg-6" }
const _hoisted_50 = { class: "form-group mb-4" }
const _hoisted_51 = { class: "col-lg-6" }
const _hoisted_52 = { class: "form-group mb-4" }
const _hoisted_53 = { class: "col-lg-6" }
const _hoisted_54 = { class: "form-group mb-4" }
const _hoisted_55 = { class: "col-lg-6" }
const _hoisted_56 = { class: "form-group mb-4" }
const _hoisted_57 = { class: "col-lg-12" }
const _hoisted_58 = { class: "form-group mb-4 only-file-upload" }
const _hoisted_59 = { class: "form-control h-100 text-center position-relative p-4 p-lg-5" }
const _hoisted_60 = { class: "product-upload" }
const _hoisted_61 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_62 = ["src"]
const _hoisted_63 = { class: "col-lg-12" }
const _hoisted_64 = { class: "d-flex justify-content-end flex-wrap gap-3" }
const _hoisted_65 = ["disabled"]
const _hoisted_66 = { key: 0 }
const _hoisted_67 = { key: 1 }
const _hoisted_68 = {
  class: "modal fade",
  id: "deleteModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_69 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_70 = { class: "modal-content" }
const _hoisted_71 = { class: "modal-footer border-0" }
const _hoisted_72 = ["disabled"]
const _hoisted_73 = { key: 0 }
const _hoisted_74 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control border-0",
            placeholder: "Search here....",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
            onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.filterProperties && _ctx.filterProperties(...args)))
          }, null, 544), [
            [_vModelText, _ctx.searchQuery]
          ]),
          _cache[22] || (_cache[22] = _createElementVNode("i", { class: "material-symbols-outlined position-absolute top-50 start-0 translate-middle-y text-secondary" }, " search ", -1))
        ]),
        _createElementVNode("button", {
          class: "btn btn-outline-primary fw-medium rounded-3 hover-bg",
          "data-bs-toggle": "modal",
          "data-bs-target": "#propertyModal",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openAddModal && _ctx.openAddModal(...args)))
        }, [...(_cache[23] || (_cache[23] = [
          _createElementVNode("span", {
            class: "d-flex align-items-center",
            style: {"gap":"5px"}
          }, [
            _createElementVNode("i", { class: "ri-add-line d-none d-sm-inline-block fs-20 lh-1" }),
            _createElementVNode("span", null, "Add New Property")
          ], -1)
        ]))])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("table", _hoisted_7, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input position-relative top-1",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectAll) = $event)),
                      onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleSelectAll && _ctx.toggleSelectAll(...args)))
                    }, null, 544), [
                      [_vModelCheckbox, _ctx.selectAll]
                    ]),
                    _cache[24] || (_cache[24] = _createElementVNode("label", { class: "position-relative fs-14" }, "Code", -1))
                  ])
                ]),
                _cache[25] || (_cache[25] = _createElementVNode("th", { scope: "col" }, [
                  _createElementVNode("span", { class: "fs-14" }, "Property")
                ], -1)),
                _cache[26] || (_cache[26] = _createElementVNode("th", { scope: "col" }, [
                  _createElementVNode("span", { class: "fs-14" }, "Address")
                ], -1)),
                _cache[27] || (_cache[27] = _createElementVNode("th", { scope: "col" }, [
                  _createElementVNode("span", { class: "fs-14" }, "Views")
                ], -1)),
                _cache[28] || (_cache[28] = _createElementVNode("th", { scope: "col" }, [
                  _createElementVNode("span", { class: "fs-14" }, "Date")
                ], -1)),
                _cache[29] || (_cache[29] = _createElementVNode("th", { scope: "col" }, [
                  _createElementVNode("span", { class: "fs-14" }, "Status")
                ], -1)),
                _cache[30] || (_cache[30] = _createElementVNode("th", { scope: "col" }, null, -1))
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedProperties, (property) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: property.id
                }, [
                  _createElementVNode("td", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        value: property.id,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedProperties) = $event))
                      }, null, 8, _hoisted_12), [
                        [_vModelCheckbox, _ctx.selectedProperties]
                      ]),
                      _createElementVNode("label", _hoisted_13, _toDisplayString(property.code), 1)
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_RouterLink, {
                      to: "/real-estate-agent/properties",
                      class: "d-flex align-items-center"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: property.imageUrl || _ctx.getDefaultImageUrl(),
                          class: "rounded-3",
                          style: {"width":"60px","height":"60px","object-fit":"cover"},
                          alt: "property-image",
                          onError: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleImageError && _ctx.handleImageError(...args)))
                        }, null, 40, _hoisted_14),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("span", _hoisted_16, _toDisplayString(property.type), 1),
                          _createElementVNode("h6", _hoisted_17, _toDisplayString(property.name), 1)
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _createElementVNode("td", _hoisted_18, [
                    _createElementVNode("p", _hoisted_19, _toDisplayString(property.address), 1)
                  ]),
                  _createElementVNode("td", _hoisted_20, _toDisplayString(property.views.toLocaleString()), 1),
                  _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.formatDate(property.date)), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass({
                      'd-inline-block border px-2 rounded-pill fs-12 fw-medium': true,
                      'bg-success-80 border-success-60 text-success-60':
                        property.status === 'Active',
                      'bg-danger-70 border-danger-60 text-danger-60':
                        property.status === 'Inactive',
                    })
                    }, _toDisplayString(property.status), 3)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("button", {
                        class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2",
                        onClick: ($event: any) => (_ctx.viewProperty(property))
                      }, [...(_cache[31] || (_cache[31] = [
                        _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, " visibility ", -1)
                      ]))], 8, _hoisted_23),
                      _createElementVNode("button", {
                        class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2",
                        "data-bs-toggle": "modal",
                        "data-bs-target": "#propertyModal",
                        onClick: ($event: any) => (_ctx.editProperty(property))
                      }, [...(_cache[32] || (_cache[32] = [
                        _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-body" }, " edit ", -1)
                      ]))], 8, _hoisted_24),
                      _createElementVNode("button", {
                        class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2",
                        onClick: ($event: any) => (_ctx.confirmDelete(property.id))
                      }, [...(_cache[33] || (_cache[33] = [
                        _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-danger" }, " delete ", -1)
                      ]))], 8, _hoisted_25)
                    ])
                  ])
                ]))
              }), 128)),
              (_ctx.filteredProperties.length === 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_26, [...(_cache[34] || (_cache[34] = [
                    _createElementVNode("td", {
                      colspan: "7",
                      class: "text-center py-4"
                    }, " No properties found ", -1)
                  ]))]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("span", _hoisted_28, " Showing " + _toDisplayString(_ctx.showingStart) + " to " + _toDisplayString(_ctx.showingEnd) + " of " + _toDisplayString(_ctx.filteredProperties.length) + " Results ", 1),
          _createElementVNode("nav", _hoisted_29, [
            _createElementVNode("ul", _hoisted_30, [
              _createElementVNode("li", _hoisted_31, [
                _createElementVNode("button", {
                  class: "page-link icon hover-bg",
                  disabled: _ctx.currentPage === 1,
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.changePage(_ctx.currentPage - 1)))
                }, [...(_cache[35] || (_cache[35] = [
                  _createElementVNode("i", { class: "material-symbols-outlined" }, "keyboard_arrow_left", -1)
                ]))], 8, _hoisted_32)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalPages, (page) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "page-item",
                  key: page
                }, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["page-link", { active: _ctx.currentPage === page }]),
                    onClick: ($event: any) => (_ctx.changePage(page))
                  }, _toDisplayString(page), 11, _hoisted_33)
                ]))
              }), 128)),
              _createElementVNode("li", _hoisted_34, [
                _createElementVNode("button", {
                  class: "page-link icon hover-bg",
                  disabled: _ctx.currentPage === _ctx.totalPages,
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.changePage(_ctx.currentPage + 1)))
                }, [...(_cache[36] || (_cache[36] = [
                  _createElementVNode("i", { class: "material-symbols-outlined" }, "keyboard_arrow_right", -1)
                ]))], 8, _hoisted_35)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("h1", _hoisted_40, _toDisplayString(_ctx.isEditing ? "Edit Property" : "Add New Property"), 1),
              _createElementVNode("button", {
                type: "button",
                class: "btn-close campaigns-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close",
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args)))
              })
            ]),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("form", {
                onSubmit: _cache[20] || (_cache[20] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, [
                      _cache[37] || (_cache[37] = _createElementVNode("label", { class: "label text-secondary" }, "Code", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control h-60 border-border-color",
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.code) = $event)),
                        placeholder: "TRZ-32",
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.formData.code]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      _cache[38] || (_cache[38] = _createElementVNode("label", { class: "label text-secondary" }, "Property Name", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control h-60 border-border-color",
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.name) = $event)),
                        placeholder: "Golden Sun Room",
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.formData.name]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _cache[39] || (_cache[39] = _createElementVNode("label", { class: "label text-secondary" }, "Property Type", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control h-60 border-border-color",
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.type) = $event)),
                        placeholder: "Luxury Apartment",
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.formData.type]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("div", _hoisted_50, [
                      _cache[40] || (_cache[40] = _createElementVNode("label", { class: "label text-secondary" }, "Address", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control h-60 border-border-color",
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.address) = $event)),
                        placeholder: "789 Northern Lights Drive, Calgary, AB",
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.formData.address]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("div", _hoisted_52, [
                      _cache[41] || (_cache[41] = _createElementVNode("label", { class: "label text-secondary" }, "Views", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        class: "form-control h-60 border-border-color",
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.views) = $event)),
                        placeholder: "2012",
                        required: "",
                        min: "0"
                      }, null, 512), [
                        [_vModelText, _ctx.formData.views]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, [
                      _cache[42] || (_cache[42] = _createElementVNode("label", { class: "label text-secondary" }, "Date", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "date",
                        class: "form-control h-60 border-border-color",
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.date) = $event)),
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.formData.date]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("div", _hoisted_56, [
                      _cache[44] || (_cache[44] = _createElementVNode("label", { class: "label text-secondary" }, "Status", -1)),
                      _withDirectives(_createElementVNode("select", {
                        class: "form-select form-control h-60",
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.status) = $event)),
                        required: ""
                      }, [...(_cache[43] || (_cache[43] = [
                        _createElementVNode("option", { value: "Active" }, "Active", -1),
                        _createElementVNode("option", { value: "Inactive" }, "Inactive", -1)
                      ]))], 512), [
                        [_vModelSelect, _ctx.formData.status]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_57, [
                    _createElementVNode("div", _hoisted_58, [
                      _cache[46] || (_cache[46] = _createElementVNode("label", { class: "label text-secondary" }, " Upload Property Images ", -1)),
                      _createElementVNode("div", _hoisted_59, [
                        _createElementVNode("div", _hoisted_60, [
                          _cache[45] || (_cache[45] = _createElementVNode("label", {
                            for: "file-upload",
                            class: "file-upload mb-0"
                          }, [
                            _createElementVNode("i", { class: "ri-folder-image-line bg-primary bg-opacity-10 p-2 rounded-1 text-primary" }),
                            _createElementVNode("span", { class: "d-block text-body fs-14" }, [
                              _createTextVNode(" Drag and drop an image or "),
                              _createElementVNode("span", { class: "text-primary text-decoration-underline" }, " Browse ")
                            ])
                          ], -1)),
                          _createElementVNode("input", {
                            id: "file-upload",
                            class: "form__file bottom-0",
                            type: "file",
                            onChange: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.handleFileUpload && _ctx.handleFileUpload(...args))),
                            accept: "image/*"
                          }, null, 32)
                        ])
                      ]),
                      (_ctx.formData.imagePreview)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                            _createElementVNode("img", {
                              src: _ctx.formData.imagePreview,
                              class: "rounded-2",
                              style: {"width":"50px","height":"50px","object-fit":"cover"}
                            }, null, 8, _hoisted_62),
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-sm btn-outline-danger ms-2",
                              onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.removeImage && _ctx.removeImage(...args)))
                            }, " Remove ")
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_63, [
                    _createElementVNode("div", _hoisted_64, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-danger py-2 px-4 fw-medium fs-16 text-white",
                        "data-bs-dismiss": "modal",
                        onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args)))
                      }, " Cancel "),
                      _createElementVNode("button", {
                        type: "submit",
                        class: "btn btn-primary py-2 px-4 fw-medium fs-16",
                        "data-bs-dismiss": "modal",
                        disabled: _ctx.isSubmitting
                      }, [
                        (_ctx.isSubmitting)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_66, [...(_cache[47] || (_cache[47] = [
                              _createElementVNode("span", {
                                class: "spinner-border spinner-border-sm",
                                role: "status",
                                "aria-hidden": "true"
                              }, null, -1),
                              _createTextVNode(" Processing... ", -1)
                            ]))]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_67, _toDisplayString(_ctx.isEditing ? "Update" : "Create"), 1))
                      ], 8, _hoisted_65)
                    ])
                  ])
                ])
              ], 32)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_68, [
        _createElementVNode("div", _hoisted_69, [
          _createElementVNode("div", _hoisted_70, [
            _cache[50] || (_cache[50] = _createElementVNode("div", { class: "modal-header border-0" }, [
              _createElementVNode("h5", { class: "modal-title" }, "Confirm Delete"),
              _createElementVNode("button", {
                type: "button",
                class: "btn-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              })
            ], -1)),
            _cache[51] || (_cache[51] = _createElementVNode("div", { class: "modal-body" }, [
              _createElementVNode("p", null, " Are you sure you want to delete this property? This action cannot be undone. ")
            ], -1)),
            _createElementVNode("div", _hoisted_71, [
              _cache[49] || (_cache[49] = _createElementVNode("button", {
                type: "button",
                class: "btn btn-secondary",
                "data-bs-dismiss": "modal"
              }, " Cancel ", -1)),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-danger",
                "data-bs-dismiss": "modal",
                onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.deleteProperty && _ctx.deleteProperty(...args))),
                disabled: _ctx.isDeleting
              }, [
                (_ctx.isDeleting)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_73, [...(_cache[48] || (_cache[48] = [
                      _createElementVNode("span", {
                        class: "spinner-border spinner-border-sm",
                        role: "status",
                        "aria-hidden": "true"
                      }, null, -1),
                      _createTextVNode(" Deleting... ", -1)
                    ]))]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_74, " Delete "))
              ], 8, _hoisted_72)
            ])
          ])
        ])
      ])
    ])
  ]))
}